import { NumberInput } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { ChangeableFieldData } from "../../ChangeableFieldWidget";
import { TextValueCell } from "../Cells/TextValueCell";
import type { ChangeableFieldTableOptions } from "../ChangeableFieldTable";

function getDefaultValueColumn<T>(
  handleChangeValue: (index: number, value: T) => void,
  getErrorForIndex: (index: number) => React.ReactNode | undefined,
  tableOptions: ChangeableFieldTableOptions = {}
): MRT_ColumnDef<ChangeableFieldData<T>> {
  return {
    header: `${tableOptions.numberValueHeader}*`,
    accessorKey: "value",
    Cell: ({ row }) =>
      tableOptions.isTextField ? (
        <div className="text-value-cell-container">
          <TextValueCell
            rightSection={tableOptions.inputGroupText}
            rightSectionWidth={tableOptions.inputGroupTextWidth}
            value={String(row.original.value || "")}
            onChange={(value) => handleChangeValue(row.index, value as T)}
          />
          <div className="table-error-messages-container">
            {getErrorForIndex(row.index)}
          </div>
        </div>
      ) : (
        <NumberInput
          decimalScale={tableOptions.numberValueDecimalScale}
          suffix={` ${tableOptions.inputGroupText}`}
          value={Number(row.original.value)}
          onChange={(value) => handleChangeValue(row.index, value as T)}
        />
      )
  };
}

export { getDefaultValueColumn };
